import { h } from 'preact';

export function AddToCart({ product, addToCartHandler }) {
  // Determine the button class based only on user and product readiness
  const buttonClass =
    product.user === null
      ? 'button enabled'
      : product.user !== null && product.ready === false
      ? 'button disabled'
      : 'button enabled';

  return (
    <div class="purchase-block__add-cart-message">
      <div class="purchase-block__add-cart">
        <a
          class={buttonClass}
          tabIndex={-1}
          onClick={addToCartHandler}
        >
          {product.add_to_cart_label
            ? product.add_to_cart_label
            : (window as any).Drupal.t('Add to cart')}
          {product.user && (
            <svg class="icon js-icon-exists" aria-hidden="true" role="img">
              <use
                xlinkHref={`/themes/custom/particle/dist/app-drupal/assets/images/sprite.svg#sprite-cart`}
              ></use>
            </svg>
          )}
        </a>
      </div>
      {!product.user && (
        <p class="purchase-block__add-cart--anon-user">{(window as any).Drupal.t('Please log in or sign up to start adding items to your cart.')}</p>
      )}
    </div>
  );
}
